import { FC } from 'react';
import ReactPaginate from 'react-paginate';
import { Box, Button } from '@chakra-ui/react';

import { ReactComponent as LeftArrowIcon } from '../assets/icons/left-arrow.svg';
import { ReactComponent as RightArrowIcon } from '../assets/icons/right-arrow.svg';

export const Paginator: FC<{
  pageCount: number;
  onPageChange: (page: number) => void;
}> = ({ pageCount, onPageChange }) => {
  return (
    <Box px="6" mt="4">
      <ReactPaginate
        breakLabel="..."
        pageRangeDisplayed={2}
        marginPagesDisplayed={3}
        containerClassName="paginator"
        pageClassName="paginator-item"
        pageCount={pageCount}
        previousLabel={
          <Button
            leftIcon={<LeftArrowIcon />}
            color="custom_blue.1"
            fontWeight="semibold"
            fontSize="sm"
            boxShadow="0 1px 2px 0 rgba(16, 24, 40, 0.05)"
            border="1px"
            borderColor="custom_blue.3"
            bg="none"
            _hover={{ bg: 'none' }}
          >
            Previous
          </Button>
        }
        nextLabel={
          <Button
            rightIcon={<RightArrowIcon />}
            color="custom_blue.1"
            fontWeight="semibold"
            fontSize="sm"
            boxShadow="0 1px 2px 0 rgba(16, 24, 40, 0.05)"
            border="1px"
            borderColor="custom_blue.3"
            bg="none"
            _hover={{ bg: 'none' }}
          >
            Next
          </Button>
        }
        renderOnZeroPageCount={null}
        onPageChange={e => onPageChange(e.selected)}
      />
    </Box>
  );
};
